import { defaultClient } from './client';
import { API_V1, API_BASE_URL } from '../constants/api';

// Sends the username and brings back the user status (SSO user or regular user).
// When the SPA is mid-OAuth flow (?k= present), the oauth_nonce is forwarded so
// the authentication backend can correlate the SSO callback with the
// authorization request.
// Spec: https://cyberint.atlassian.net/wiki/spaces/~dean/pages/1840185360/RFC+Argos+OAuth+2.1+Authorization+Server+Design (§8.2).
export const getLoginStatus = (username, oauthNonce) => {
  const body = { username };
  if (oauthNonce) {
    body.oauth_nonce = oauthNonce;
  }
  return defaultClient.post(`${API_V1}/authentication/configuration`, body);
};

export const forgotPassword = payload =>
  defaultClient.post(`${API_BASE_URL}/authentication/reset_password_by_user`, payload);
